import { render } from "./BaseItemsList.vue?vue&type=template&id=b85f73a6&scoped=true"
import script from "./BaseItemsList.vue?vue&type=script&lang=js"
export * from "./BaseItemsList.vue?vue&type=script&lang=js"

import "./BaseItemsList.vue?vue&type=style&index=0&id=b85f73a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b85f73a6"],['__file',"src/components/BaseItemsList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b85f73a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b85f73a6', __exports__)) {
    api.reload('b85f73a6', __exports__)
  }
  
  module.hot.accept("./BaseItemsList.vue?vue&type=template&id=b85f73a6&scoped=true", () => {
    api.rerender('b85f73a6', render)
  })

}


export default __exports__